import React, { Fragment } from 'react';
import moment from 'moment';

var FormattedTime = function FormattedTime(_ref) {
  var time = _ref.time,
      variant = _ref.variant;
  var Tag = variant || Fragment;
  var momentTime = moment(time, 'hh:mm A');
  return momentTime.isValid() ? React.createElement(Tag, null, momentTime.format('LT')) : React.createElement(React.Fragment, null, "Invalid date");
};

export default FormattedTime;